import { render, staticRenderFns } from "./PconEditMain.vue?vue&type=template&id=046c97cc&scoped=true&"
import script from "./PconEditMain.vue?vue&type=script&lang=js&"
export * from "./PconEditMain.vue?vue&type=script&lang=js&"
import style0 from "./PconEditMain.vue?vue&type=style&index=0&id=046c97cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c97cc",
  null
  
)

export default component.exports